import React from "react";

const Footer = ({
    pageNumber,
    totalPages
}) => {

    return(

        <div >

          

        </div>

    )

}

export default Footer;